export default "__VITE_ASSET__BDsVSjiZ__"